// 03c — code entry. 76px tall, 38px mono, centred, 0.24em tracking. The two
// escape hatches (resend / different email) are immediately visible — no timer.
import { Icon } from '../../lib/icons';
import { MONO } from '../primitives';

const CARD: React.CSSProperties = {
  background: 'var(--deeper)',
  border: '1px solid rgba(127,227,232,0.24)',
  borderRadius: 16,
  padding: '22px 20px',
};

export function CodeStep({
  email,
  code,
  onCode,
  onVerify,
  onResend,
  onBackToEmail,
  busy,
  codeErr,
}: {
  email: string;
  code: string;
  onCode: (v: string) => void;
  onVerify: () => void;
  onResend: () => void;
  onBackToEmail: () => void;
  busy: boolean;
  codeErr: '' | 'wrong' | 'expired';
}) {
  const codeErrText =
    codeErr === 'expired'
      ? 'that code has run out. send yourself another one.'
      : "that's not it. try again — nothing locks you out.";

  return (
    <div className="on-card" style={CARD}>
      <label
        htmlFor="wh-code"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          fontSize: 21,
          fontWeight: 700,
          letterSpacing: '-0.02em',
          marginBottom: 6,
        }}
      >
        <Icon name="key" size={28} color="var(--cyan)" style={{ flex: 'none' }} />
        type the code
      </label>
      <div style={{ fontSize: 17, color: 'var(--muted)', marginBottom: 16 }}>
        sent to {email}. it's in the subject line. good for 20 minutes.
      </div>
      <input
        id="wh-code"
        className="wh-input"
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={6}
        placeholder="000000"
        value={code}
        onChange={(e) => onCode(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onVerify();
        }}
        style={{
          minHeight: 76,
          padding: '10px 12px',
          fontFamily: MONO,
          fontSize: 38,
          fontWeight: 700,
          letterSpacing: '0.24em',
          textAlign: 'center',
        }}
      />

      {codeErr && (
        <div
          style={{
            marginTop: 14,
            background: 'rgba(255,59,31,0.13)',
            border: '1px solid var(--orange)',
            borderRadius: 12,
            padding: '14px 16px',
            fontSize: 18,
            lineHeight: 1.45,
          }}
        >
          {codeErrText}
        </div>
      )}

      <button
        type="button"
        className="wh-cta on-card"
        onClick={onVerify}
        disabled={busy}
        style={{ width: '100%', minHeight: 62, marginTop: 16, fontSize: 21, fontWeight: 700 }}
      >
        that's the code
      </button>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 14 }}>
        <button
          type="button"
          className="wh-ghost on-card"
          onClick={onResend}
          style={{ flex: '1 1 150px', minHeight: 54, fontSize: 17 }}
        >
          send me another code
        </button>
        <button
          type="button"
          className="wh-ghost-neutral on-card"
          onClick={onBackToEmail}
          style={{ flex: '1 1 150px', minHeight: 54, fontSize: 17 }}
        >
          use a different email
        </button>
      </div>
      <div
        style={{
          fontFamily: MONO,
          fontSize: 14,
          lineHeight: 1.6,
          color: 'var(--muted)',
          marginTop: 18,
          borderTop: '1px solid var(--hairline)',
          paddingTop: 16,
        }}
      >
        still stuck? text me.
      </div>
    </div>
  );
}
